module.exports = __webpack_public_path__ + "img/list.b5fe9f6f.svg";